export default __webpack_public_path__ + "static/coninsa-builders-new-768f30f7de86b0f73b485df313189997.jpg";